<template>
  <div class="card">
    <div class="card-body">

      <h5 class="card-title">{{ text }}</h5>
      <h6 class="card-subtitle mb-2 text-body-secondary">{{ subtitle }}</h6>

      <video
        class="vjs-stihl video-js"
        controls
        preload="none"
        :poster="resolveURL(poster)"
        data-setup='{"aspectRatio":"16:9", "playbackRates": [1, 1.5, 2]}'>
        <source
          v-for="(item, i) in sources"
          :key="i"
          :src="resolveURL(item.src)"
          :type="item.type" />
        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to a web browser that
          <a href="https://videojs.com/html5-video-support/" target="_blank" rel="noopener noreferrer">
            supports HTML5 video</a>
        </p>
        <track
          v-for="(item, i) in tracks"
          :key="i"
          :kind="item.type"
          :src="resolveURL(item.src)"
          :srclang="item.lang"
          :label="item.label"
          :default="item.default">
      </video>

    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import 'video.js';
import 'video.js/dist/video-js.min.css';

export interface VideoSource {
  type: 'video/mp4' | 'video/webm',
  src: string
}

export interface TrackSource {
  type: 'subtitles' | 'captions' | 'chapters' | 'descriptions' | 'metadata',
  src: string,
  lang: string,
  label: string,
  default: boolean,
}

export default defineComponent({
  name: 'TutorialCard',
  props: {
    subtitle: { type: String, required: true },
    text: { type: String, required: true },
    poster: { type: String, required: true },
    sources: { type: Array as PropType<VideoSource[]>, required: true },
    tracks: { type: Array as PropType<TrackSource[]>, default: new Array<TrackSource>() },
  },
  methods: {
    resolveURL(ressource: string) {
      // const src = require.context('@/assets/', false);
      if (ressource.startsWith('http')) return ressource;
      // resolve asset URL (in DEV & prod modes)
      return `${import.meta.env.BASE_URL}assets/tutorials/${ressource}`;
      // return import.meta.resolve(`./assets/tutorials/${ressource}`);
    },
  },
});
</script>

<style scoped>
.vjs-stihl {
  width: 32rem;
  height: 18rem;
  /*color: #00ff00;*/
}

/* hide controls at the start */
.vjs-stihl .vjs-control-bar {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

/* Change the border of the big play button. */
.vjs-stihl .vjs-big-play-button {
  border-color: var(--orange-base);
  background-color: var(--orange-base);
}
</style>
